import { Link } from "@tanstack/react-router";
import { Panel } from "@/design/primitives";

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <Panel brackets className="p-8 text-center">
        <div className="af-display text-[28px] font-semibold" style={{ color: "var(--critical)" }}>
          404
        </div>
        <p className="mt-2 text-[11px]" style={{ color: "var(--text-secondary)" }}>
          Tahle souřadnice ve Factory neexistuje.
        </p>
        <Link to="/" className="mt-4 inline-block text-[12px] tracking-[0.16em]">
          ← COMMAND CENTER
        </Link>
      </Panel>
    </div>
  );
}
